import axios from "axios";

export default {
  namespaced: true,
  state: {
    // themelist: {},
    firstLevelTheme: null,
    secondLevelTheme: null,
    selectedTheme: null
  },
  actions: {},
  mutations: {
    setFirstLevelTheme(state, firstLevelTheme) {
      state.firstLevelTheme = firstLevelTheme;
    },
    setSecondLevelTheme(state, secondLevelTheme) {
      state.secondLevelTheme = secondLevelTheme;
    },
    setSelectedTheme(state, selectedTheme) {
      state.selectedTheme = selectedTheme;
    },
  },
  getters: {}
}
